import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Card,
  Typography,
  Button,
  Backdrop,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Paper,
  Chip,
  ListItemIcon,
} from "@mui/material";
import { useEffect, useState } from "react";
import DashboardLayout from "../components/dashboard_layout";
import axios from "../../axios";
import AppLogo from "../../app/assets/logo.png";
import { useNavigate } from "react-router-dom";

function ApplicationsPage() {
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`practitioners/applications.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setApplications(result.data.data.applications);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getStatusColor(status) {
    if (status === "approved") {
      return "success";
    } else if (status === "declined") {
      return "error";
    } else {
      return "warning";
    }
  }

  return (
    <DashboardLayout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box>
        <Box px={1} mb={1} display="flex" justifyContent="space-between">
          <Typography variant="h6">My Applications</Typography>
          <Box mb={3}>
            <Button
              startIcon={<Icon>chevron_left</Icon>}
              onClick={() => navigate("/dashboard")}
            >
              Dashboard
            </Button>
          </Box>
        </Box>
        <Box mb={3}>
          <Divider />
        </Box>
        <Paper>
          <Box p={2}>
            {applications.length > 0 ? (
              <List>
                {applications.map((row, idx) => (
                  <Box mb={5}>
                    <ListItem
                      onClick={() => navigate(`/applications/${row.reference}`)}
                    >
                      <ListItemIcon>
                        <Typography>{idx + 1}.</Typography>
                      </ListItemIcon>
                      <ListItemText
                        primary={`ID: ${row.reference}`}
                        secondary={row.created}
                      />
                      <Box align="center" mb={0}>
                        <Box mt={0}>
                          <Chip
                            // label={!row.closed ? row.status : "closed"}
                            label={!row.closed ? "under-review" : "closed"}
                            variant="outlined"
                            color={
                              !row.closed
                                ? getStatusColor(row.status)
                                : "default"
                            }
                          />
                        </Box>
                      </Box>
                    </ListItem>
                    <Divider />
                  </Box>
                ))}
              </List>
            ) : (
              <Typography>
                No active applications yet.{" "}
                <a href="/apply">Click here to apply now</a>
              </Typography>
            )}
          </Box>
        </Paper>
      </Box>
    </DashboardLayout>
  );
}

export default ApplicationsPage;
